import { render, staticRenderFns } from "./SurfVideo.vue?vue&type=template&id=38552b5a&scoped=true&lang=pug&"
import script from "./SurfVideo.vue?vue&type=script&lang=js&"
export * from "./SurfVideo.vue?vue&type=script&lang=js&"
import style0 from "./SurfVideo.vue?vue&type=style&index=0&id=38552b5a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38552b5a",
  null
  
)

export default component.exports